import type { ReactElement } from 'react';
import { Ctext } from '../Ctext';
import type { ChackerheaderTextVisualProps } from './ChackerheaderTypes';

const HACKER_HEADER_OPENING_BRACKET_VALUE = "hackerHeaderOpeningBracket";
const HACKER_HEADER_CLOSING_BRACKET_VALUE = "hackerHeaderClosingBracket";

interface ChackerheaderBracketProps extends ChackerheaderTextVisualProps {
  bracket: '[' | ']';
}

export function ChackerheaderBracket({
  bracket,
  fontSize,
  fontWeight,
  opacity,
  textColor,
}: ChackerheaderBracketProps): ReactElement {
  return (
    <Ctext
      color={textColor}
      opacity={opacity}
      size={fontSize}
      weight={fontWeight}
    >
      {bracket}
    </Ctext>
  );
}
